import GameConfig from './GameConfig'

const gameMapContainer = document.querySelector('.game-map-container')
const gameArea = document.querySelector('.game-area')
const player = document.querySelector('.player')
const playerCanoe = document.querySelector('.player-canoe')
const gamePropmtElement = document.querySelector('.game-prompt')
const gamePropmtTextElement = document.querySelector('.game-prompt__text')
const gamePropmtDoElement = document.querySelector('.game-prompt__do')
const gamePropmtDontElement = document.querySelector('.game-prompt__dont')
let isGameCompleted = false;
let onMapComplete = null
const positionElement = (element, gridPosition) => {
  if (gridPosition.x < GameConfig.grid.x) {
    const calcX = gridPosition.x * GameConfig.elements.size.width
    element.style.left = `${calcX}px`;
  }
  if (gridPosition.y < GameConfig.grid.y) {
    const calcY = gridPosition.y * GameConfig.elements.size.height
    element.style.top = `${calcY}px`;
  }
}

const hideGamePrompt = () => {
  GameConfig.state.prompt.isOpen = false
  gamePropmtElement.classList.add('hidden');
  gamePropmtTextElement.innerHTML = '';
  gamePropmtDoElement.onclick = () => {};
  gamePropmtDontElement.onclick = () => {};
}

const showGamePrompt = (
  promtText = '', 
  confirmHandler = null, 
  cancelHandler = hideGamePrompt,
  confirmText = 'Do it!',
  cancelText = 'Not really.'
) => {
  GameConfig.state.prompt.isOpen = true
  gamePropmtTextElement.innerHTML = promtText;
  
  if (typeof confirmHandler === 'function') {
    if(gamePropmtDoElement.classList.contains('hidden')) gamePropmtDoElement.classList.remove('hidden')
    gamePropmtDoElement.onclick = confirmHandler;
  } else {
    if(!gamePropmtDoElement.classList.contains('hidden')) gamePropmtDoElement.classList.add('hidden')
  }

  if (typeof cancelHandler === 'function') {
    if(gamePropmtDontElement.classList.contains('hidden')) gamePropmtDontElement.classList.remove('hidden')
    gamePropmtDontElement.onclick = cancelHandler;
  } else {
    if(!gamePropmtDontElement.classList.contains('hidden')) gamePropmtDontElement.classList.add('hidden')
  }

  gamePropmtDoElement.innerHTML = confirmText
  gamePropmtDontElement.innerHTML = cancelText

  gamePropmtElement.classList.remove('hidden');
}

const getContentFromType = (type) => {
  switch(type){
    case 'tree':
      return "🌳"
    case 'house':
      return "🏠"
    case 'canoe':
      return "🛶"
    case 'water':
      return "🌊"
    case 'mountain':
      return "🗻"
  }
}

const createLevel = () => {
  GameConfig.elements.levelLayout.map(levelElementData => {
    const levelElement = document.createElement('p')
    levelElement.classList.add(`game-element`)
    levelElement.classList.add(`game-${levelElementData.type}`)
    levelElement.classList.add(levelElementData.type)
    levelElement.innerHTML = getContentFromType(levelElementData.type)
    positionElement(levelElement, levelElementData)
    gameArea.appendChild(levelElement)
  })
}

const checkPlayerCollision = (positionToCheck) => {
  let hasCollision = false;
  GameConfig.elements.levelLayout.map(levelElementData => {
    if (levelElementData.x === positionToCheck.x && levelElementData.y === positionToCheck.y) {
      switch(levelElementData.type){
        case 'tree':
          if (GameConfig.state.items.forest === undefined) {
            showGamePrompt('Are you sure you want to enter the forest?', () => {
              hideGamePrompt()
              return onMapComplete ? onMapComplete() : null
            });
            hasCollision = true;
          }
          break;
        
        case 'house':
          showGamePrompt('Welcome home! Game Over',null, null);
          break;
        
        case 'canoe':
          if (GameConfig.state.items.mountain === undefined) {
            showGamePrompt('A canoe!');
            hasCollision = true
          } else {
            if (GameConfig.state.items.canoe === undefined) {
              showGamePrompt('A canoe!', () => {
                hideGamePrompt()
                playerCanoe.classList.remove('hidden')
                document.querySelector('.game-canoe').classList.add('hidden')
                GameConfig.state.items.canoe = 'canoe'
              }, hideGamePrompt, 'Get it!');
              hasCollision = true
            }
          }
          break;
        
        case 'water':
          if (GameConfig.state.items.canoe !== 'canoe') {
            showGamePrompt('Water... dammit!');
            hasCollision = true;
          }
          break;
        
        case 'mountain':
          if (GameConfig.state.items.mountain === undefined) {
            if (GameConfig.state.items.forest !== undefined) {
              showGamePrompt('Wanna climb these big moutains?', () => {
                hideGamePrompt()
                return onMapComplete ? onMapComplete() : null
              });
            } else {
              showGamePrompt('Those are some big moutains!');
            }
            hasCollision = true;
          }
          break;
      }
    }
  })
  return hasCollision
}

const addInputListener = () => {
  window.addEventListener('keydown', (e) => {
    if (GameConfig.state.map.isHidden) return
    e.preventDefault()
    if (GameConfig.state.prompt.isOpen) return
    let nextPosition = {
      ...GameConfig.player.position
    }
    switch(e.key) {
      case 'w':
      case 'ArrowUp':
        if (nextPosition.y <= 0) return
        nextPosition.y -= GameConfig.player.step
        break;
      case 's':
      case 'ArrowDown':
        if (nextPosition.y >= GameConfig.grid.y - GameConfig.player.step) return
        nextPosition.y += GameConfig.player.step
        break;
      case 'a':
      case 'ArrowLeft':
        if (nextPosition.x <= 0) return
        nextPosition.x -= GameConfig.player.step
        break;
      case 'd':
      case 'ArrowRight':
        if (nextPosition.x >= GameConfig.grid.x - GameConfig.player.step) return
        nextPosition.x += GameConfig.player.step
        break;
      default:
        break;
    }

    if (!checkPlayerCollision(nextPosition)) {
      GameConfig.player.position.x = nextPosition.x
      GameConfig.player.position.y = nextPosition.y
    }
    
    positionElement(player, GameConfig.player.position)
  })
}

const initMap = (onComplete) => {
  onMapComplete = () =>  {
    onComplete()
    hideMap()
  }
  
  GameConfig.grid.x = GameConfig.size.width/GameConfig.elements.size.width;
  GameConfig.grid.y = GameConfig.size.height/GameConfig.elements.size.height;
  hideGamePrompt()
  createLevel()
  addInputListener()
}

const hideMap = () => {
  gameMapContainer.classList.add('hidden')
  GameConfig.state.map.isHidden = true
}

const showMap = (item, onComplete) => {
  gameMapContainer.classList.remove('hidden')
  GameConfig.state.map.isHidden = false
  GameConfig.state.items[item] = item
  onMapComplete = () =>  {
    onComplete()
    hideMap()
  }
}

export {
  initMap,
  hideMap,
  showMap
}
